import type {DeflateOptions} from 'fflate';

export const DEFAULT_COMPRESSION_SETTINGS: DeflateOptions = {
	level: 5,
	mem: 2,
};
